// Google Analytics 4 (gtag.js) for marketing's landing-page -> signup-form
// funnel. Loaded ONLY on the prod host so dev/local traffic never lands in the
// shared GA4 property, mirroring posthog.js / recaptcha-key.js. The measurement
// id is public (it ships in the bundle either way). Cross-domain session
// continuity is a console setting ("Configure your domains" on this property),
// not code — the standard config below is all the tag needs on its end.
const MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-D48EKZS10G";

const isProdHost =
  typeof window !== "undefined" &&
  window.location.hostname === "public-tools.prod.aws.cinch.io";

if (isProdHost) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID);
}
